<template>
    <b-modal id="onboarding-modal" hide-footer hide-header centered @shown="onShow">
        <OnboardingComponent></OnboardingComponent>
    </b-modal>
</template>

<script>
import { defineComponent } from 'vue'
import OnboardingComponent from './OnboardingComponent.vue'
import WithOnboarding from '../mixins/WithOnboarding'

export default defineComponent({
    name: 'OnboardingModal',
    components: {
        OnboardingComponent,
    },
    mixins: [WithOnboarding],
    methods: {
        onShow() {
            // statsig exposure
            if (!this.onboardingComplete && this.useCurrentOnboarding) {
                this.recordRoleAndMarketingCollectionExposure()
            }
        },
    },
})
</script>

<style scoped>
.close-icon {
    top: 5px;
    right: 5px;
    height: 24px;
    width: 24px;
    z-index: 2;
}
</style>
